import React, { FormEvent, useState } from 'react';
import sellerAccountService from '../services/sellerAccountService';
import { useAppContext } from '../context/AppContext';

interface PasswordErrors {
    currentPassword?: string;
    newPassword?: string;
    confirmPassword?: string;
}

const ChangePasswordPage = () => {

    const { sellerAccount } = useAppContext();

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [passwordErrors, setPasswordErrors] = useState<PasswordErrors>({});
    const [serviceStatus, setServiceStatus] = useState({ type: '', message: '' });

    const validatePasswordChange = () => {
        let errors: PasswordErrors = {};
        if (!currentPassword) {
            errors.currentPassword = "Current Password is required";
        }
        if (!newPassword) {
            errors.newPassword = "New Password is required";
        } else if (newPassword.length < 6) {
            errors.newPassword = "New Password must be at least 6 characters long";
        }
        if (!confirmPassword) {
            errors.confirmPassword = "Confirm Password is required";
        } else if (confirmPassword.length < 6) {
            errors.confirmPassword = "Confirm Password must be at least 6 characters long";
        }
        if (!errors.currentPassword && !errors.newPassword && !errors.confirmPassword) {
            if (newPassword === currentPassword) {
                errors.newPassword = "New Password cannot be the same as Current Password";
            }
            if (newPassword !== confirmPassword) {
                errors.confirmPassword = "New Password and Confirm Password do not match";
            }
        }
        setPasswordErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const handlePasswordSubmit = (e: FormEvent) => {
        const updateSellerPassword = async () => {
            try {
                const result = await sellerAccountService.updateSellerAccountPassword(currentPassword, newPassword);
                if (result === 'Success') {
                    setServiceStatus({ ...serviceStatus, type: "Success", message: "The password has been updated successfully" });
                } else if (result === "InvalidOldPassword") {
                    setServiceStatus({ ...serviceStatus, type: "Error", message: 'The old password you entered is incorrect' });
                }
                else {
                    setServiceStatus({ ...serviceStatus, type: "Error", message: 'Failed to update password' });
                }
            } catch (error) {
                setServiceStatus({ ...serviceStatus, type: "Error", message: 'Failed to update password' });
            }
            setIsSubmitting(false);
        }
        e.preventDefault();
        setServiceStatus({ ...serviceStatus, type: "", message: '' });
        if (validatePasswordChange()) {
            setIsSubmitting(true);
            updateSellerPassword();
        }
    };

    return (
        <div className='mt-3'>
            <div className="card rounded-0">
                <div className="card-body card-body p-4">
                    <h5 className="card-title mb-4">Change Password</h5>
                    {(serviceStatus.type === "Success") ? (
                        <div className="col-md-12 clearfix"><div className="alert alert-success p-2 mb-0">{serviceStatus.message}</div></div>
                    ) : (
                        <form className="row g-3" onSubmit={handlePasswordSubmit}>
                            <div className="col-12">
                                <label htmlFor="inputCurrentPassword" className="form-label">Current Password</label>
                                <input
                                    type="password"
                                    className={`form-control ${passwordErrors.currentPassword ? ` is-invalid` : ``}`}
                                    id="inputCurrentPassword"
                                    maxLength={200}
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                {passwordErrors.currentPassword && <div className="invalid-feedback">{passwordErrors.currentPassword}</div>}
                            </div>
                            <div className="col-12">
                                <label htmlFor="inputNewPassword" className="form-label">New Password</label>
                                <input
                                    type="password"
                                    className={`form-control ${passwordErrors.newPassword ? ` is-invalid` : ``}`}
                                    id="inputNewPassword"
                                    value={newPassword}
                                    maxLength={200}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                {passwordErrors.newPassword && <div className="invalid-feedback">{passwordErrors.newPassword}</div>}
                            </div>
                            <div className="col-12">
                                <label htmlFor="inputConfirmPassword" className="form-label">Confirm Password</label>
                                <input
                                    type="password"
                                    className={`form-control ${passwordErrors.confirmPassword ? ` is-invalid` : ``}`}
                                    id="inputConfirmPassword"
                                    maxLength={200}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                {passwordErrors.confirmPassword && <div className="invalid-feedback">{passwordErrors.confirmPassword}</div>}
                            </div>
                            {serviceStatus.type === "Error" && <div className="col-md-12 clearfix"><div className="alert alert-danger p-2 mb-0">{serviceStatus.message}</div></div>}
                            <div className="col-md-12 pt-2">
                                <button type="submit" className="btn btn-dark rounded-0" disabled={isSubmitting}>
                                    {isSubmitting ? (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving ...</>) : ("Save")}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ChangePasswordPage;